// Copyright (c) 2016 Deere & Company

import allClaims from './all-claims';
import attachmentClaim from './attachment-claim-route';
import batteryClaim from './battery-claim-route';
import claimSearch from './claim-search';
import claimsInProgress from './claims-in-progress';
import claimsRoot from './claims-root';
import dealerInvoices from './dealer-invoice';
import editAttachmentClaim from './edit-attachment-claim-route';
import editBatteryClaim from './edit-battery-claim-route';
import editIncentiveClaim from './edit-incentive-claim-route';
import editJdpClaim from './edit-jdp-claim-route';
import editMaintenancePlanClaim from './edit-maintenance-plan-route';
import editMassChannelPdiClaim from './edit-mass-channel-pdi-route';
import editMccFollowupClaim from './edit-mass-channel-customer-followup-route';
import editNormalClaim from './edit-normal-claim-route';
import editPartsClaim from './edit-parts-claim-route';
import editPipClaim from './edit-pip-claim-route';
import editSpaClaim from './edit-spa-claim-route';
import editTrackClaim from './edit-track-claim-route';
import editWearPartsClaim from './edit-wear-parts-claim-route';
import invoiceDetails from './invoice-details';
import jdpClaim from './jdp-claim-route';
import laborRateDealers from './labor-rate-dealers';
import maintenancePlanClaim from './maintenance-plan-route';
import massChannelPdiClaim from './mass-channel-pdi-route';
import mccFollowupClaim from './mass-channel-customer-followup-route';
import newIncentiveClaim from './incentive-claim-route';
import newNormalClaim from './normal-claim-route';
import newWearPartsClaim from './wear-parts-claim-route';
import partsClaim from './parts-claim-route';
import pipClaimWithPinAndPipId from './pip-claim-route-with-pin-and-pip-id';
import pipClaimWithPipId from './pip-claim-route-with-pip-id';
import reports from './reports';
import spaClaim from './spa-claim-route';
import trackClaim from './track-claim-route';

export default state => ({
    ...claimsRoot,
    childRoutes: [
        allClaims,
        attachmentClaim,
        batteryClaim,
        claimSearch,
        claimsInProgress,
        dealerInvoices,
        editAttachmentClaim,
        editBatteryClaim,
        editIncentiveClaim,
        editJdpClaim,
        editMaintenancePlanClaim,
        editMassChannelPdiClaim,
        editMccFollowupClaim,
        editNormalClaim,
        editPartsClaim,
        editPipClaim,
        editSpaClaim,
        editTrackClaim,
        editWearPartsClaim,
        newIncentiveClaim,
        invoiceDetails,
        jdpClaim,
        laborRateDealers,
        maintenancePlanClaim,
        massChannelPdiClaim,
        mccFollowupClaim,
        newNormalClaim,
        partsClaim,
        pipClaimWithPinAndPipId,
        pipClaimWithPipId,
        reports(state),
        spaClaim,
        trackClaim,
        newWearPartsClaim
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/claims/all')
    }
});



// WEBPACK FOOTER //
// ./src/routes/claims/index.js